<template>
    <div>

        <b-alert show variant="info">
            <b-row>
                <b-col>
                    <b-icon icon="check2-square" font-scale="1.5"></b-icon> L'affiliation à l'Assurance-Maladie est conditionnée à la <b-link href="#" @click="$actions.showFaq($bvModal, 'titre-de-sejour')">régularité de séjour en France</b-link>
                </b-col>
            </b-row>
            <b-row class="mt-2">
                <b-col>
                    <b-icon icon="check2-square" font-scale="1.5"></b-icon> L'Assurance-Maladie pourra être amenée à vous réclamer la copie de votre titre de séjour
                </b-col>
            </b-row>
        </b-alert>

        <b-row class="mt-3">
            <b-col>
                <strong>De quel titre de séjour ou visa en cours de validité disposerez-vous pour vos séjours temporaires en France ?*</strong> <b-icon v-b-modal.info-titre-a-disposition icon="info-circle" font-scale="1.5"></b-icon>
                <b-modal id="info-titre-a-disposition" centered :ok-only="true" hide-header>
                    Si vous ne savez pas de quel titre de séjour relève votre situation, nous vous invitons à consulter le site <b-link href="https://www.service-public.fr" target="_blank">www.service-public.fr</b-link> ou à contacter votre ambassade/consulat afin d'obtenir cette information.
                </b-modal>
            </b-col>
        </b-row>

        <b-row class="ml-3 mt-3">
            <b-col>
                <b-form-group>
                    <b-form-checkbox
                        v-model="titreAutreVisaSchengen"
                        switch
                        :disabled="disabledTitreAutreVisaSchengen"
                        value="1"
                        unchecked-value="0">
                        Titre de séjour autre que visa Schengen (carte de résident retraité, carte de séjour retraité, certificat de résidence algérien retraité...) <b-icon v-b-modal.info-titre-autre-visa-schengen icon="info-circle" font-scale="1.5" @click.prevent></b-icon>
                    </b-form-checkbox>
                </b-form-group>
                <b-modal id="info-titre-autre-visa-schengen" centered :ok-only="true" hide-header>
                    Nous vous encourageons à vous procurer l'un de ces titres de séjour car leur durée de validité vous dispensera d'un renouvellement de titre à chaque séjour. Retrouvez toutes les démarches sur <b-link href="https://www.service-public.fr" target="_blank">www.service-public.fr</b-link>
                </b-modal>
            </b-col>
        </b-row>

        <b-row class="ml-3 mt-3">
            <b-col>
                <b-form-group>
                    <b-form-checkbox
                        v-model="visaSchengen"
                        switch
                        :disabled="disabledVisaSchengen"
                        value="1"
                        unchecked-value="0">
                        Visa Schengen (avec assurance privée obligatoire) <b-icon v-b-modal.info-titre-visa-schengen icon="info-circle" font-scale="1.5" @click.prevent></b-icon>
                    </b-form-checkbox>
                </b-form-group>
                <b-modal id="info-titre-visa-schengen" centered :ok-only="true" hide-header>
                    Les titulaires d'un visa Schengen doivent obligatoirement souscrire une assurance privée les couvrant à hauteur minimum de 30.000 euros pour les soins qui leur seraient dispensés au cours de leurs séjours. Seuls les frais non couverts par cette assurance privée devront être adressés au CNAREFE accompagnés d'une attestation de refus de prise en charge.
                </b-modal>
            </b-col>
        </b-row>

        <b-row class="ml-3 mt-3">
            <b-col>
                <b-form-group>
                    <b-form-checkbox
                        v-model="passeportAutorisantSejour"
                        switch
                        :disabled="disabledPasseportAutorisantSejour"
                        value="1"
                        unchecked-value="0">
                        Ma nationalité/citoyenneté me permet de séjourner en France temporairement en présentant simplement mon passeport en cours de validité <b-icon v-b-modal.info-passeport-valide icon="info-circle" font-scale="1.5" @click.prevent="$actions.showFaq($bvModal, 'titre-de-sejour')"></b-icon>
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row class="pt-3">
            <b-col cols="8">
                <strong>Êtes-vous déjà en possession de ce(s) document(s) ?</strong>
            </b-col>
            <b-col cols="4" class="text-right">
                <b-form-group>
                    <b-form-radio-group
                        v-model="possessionTitreSejour"
                        :options="possessionTitreSejourOptions"
                        name="possession-titre-de-sejour"
                    ></b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>

        <BackNext
            :buttons="buttons"/>

    </div>
</template>

<script>
import BackNext from '@/components/BackNext'

export default {
    name: 'RegulariteDeSejour',
    components: {
        BackNext
    },
    data() {
        return {
            possessionTitreSejourOptions: [
                { text: 'Oui', value: 1 },
                { text: 'Non', value: 0 }
            ]
        }
    },
    mounted() {

        // Renvoi vers l'URL du site
        if (this.$store.endOfInscription || !this.$actions.getStepChecked('accueil') || !this.$actions.getStepChecked('identite') || !this.$actions.getStepChecked('coordonnees')) {
            window.location = this.$config.SITE
        }

        // Envoi un évenement onSetStepper pour mettre a jour l'étape
        this.$emit('onSetStepper', 'regulariteDeSejour');
    },
    computed: {
        titreAutreVisaSchengen: {
            get() {
                return this.$store.titreAutreVisaSchengen
            },
            set(val) {
                this.$store.titreAutreVisaSchengen = val
            }
        },
        disabledTitreAutreVisaSchengen: {
            get() {
                return this.$store.disabledTitreAutreVisaSchengen
            },
            set(val) {
                this.$store.disabledTitreAutreVisaSchengen = val
            }
        },
        visaSchengen: {
            get() {
                return this.$store.visaSchengen
            },
            set(val) {
                this.$store.visaSchengen = val
            }
        },
        disabledVisaSchengen: {
            get() {
                return this.$store.disabledVisaSchengen
            },
            set(val) {
                this.$store.disabledVisaSchengen = val
            }
        },
        passeportAutorisantSejour: {
            get() {
                return this.$store.passeportAutorisantSejour
            },
            set(val) {
                this.$store.passeportAutorisantSejour = val
            }
        },
        disabledPasseportAutorisantSejour: {
            get() {
                return this.$store.disabledPasseportAutorisantSejour
            },
            set(val) {
                this.$store.disabledPasseportAutorisantSejour = val
            }
        },
        possessionTitreSejour: {
            get() {
                return this.$store.possessionTitreSejour
            },
            set(val) {
                this.$store.possessionTitreSejour = val
            }
        },
        checkAll: function() {
            return ((this.titreAutreVisaSchengen == 1 || this.visaSchengen == 1 || this.passeportAutorisantSejour == 1) &&
                    this.possessionTitreSejour != null) ? true : false;
        },
        buttons: function() {
            return {
                routes: {
                    back: 'Coordonnees',
                    next: 'PiecesAJoindre'
                },
                next: this.$actions.getStepChecked('accueil') && this.$actions.getStepChecked('identite') && this.$actions.getStepChecked('coordonnees') && this.$actions.getStepChecked('regulariteDeSejour')
            }
        }
    },
    watch: {
        titreAutreVisaSchengen: function() {
            this.disabledVisaSchengen = this.disabledPasseportAutorisantSejour = !(this.titreAutreVisaSchengen == 0)
        },
        visaSchengen: function() {
            this.disabledTitreAutreVisaSchengen = this.disabledPasseportAutorisantSejour = !(this.visaSchengen == 0)
        },
        passeportAutorisantSejour: function() {
            this.disabledTitreAutreVisaSchengen = this.disabledVisaSchengen = !(this.passeportAutorisantSejour == 0)
        },
        // Set l'état de controle général de la page dès lors que checkAll changera d'état
        checkAll: function(val) {
            this.$actions.setStepChecked('regulariteDeSejour', val);
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RegulariteDeSejour.vue